const getActiveSection = (sections, marker, isNearPageBottom = false) => {
  if (sections.length === 0) return null
  if (isNearPageBottom) return sections[sections.length - 1].id

  let active = null
  sections.forEach((section) => {
    if (section.top <= marker) active = section.id
  })
  return active
}

module.exports = { getActiveSection }
